import { action, observable } from 'mobx'
import { browserName, browserVersion, osName } from 'react-device-detect'
import { IUser } from './RegisterTypes'
import configurations from '../utils/config/configurations'
import { postToApi, injectTokenInApi, injectLanguageInApi, putToApi } from '../services/apiService'
import { initialiseAnalyticsUser } from '../services/analyticsService'
import axios from 'axios'
import i18n from '../utils/config/i18n'
class RegisterStore {
  @observable user: IUser | null = null;
  @observable partnerCode: string | null = null
  @observable countryCode = 'US';
  @observable apiToken: string | null = null;
  @observable connectedToken: string | null = null;

  @action async registerDevice(partnerCode?: string): Promise<boolean> {
    if (partnerCode) {
      this.partnerCode = partnerCode
    }
    // always new device for now
    const body = {
      device: {
        type: 'web',
        customerAppName: configurations.UFO_APP_NAME,
        customerAppVersion: configurations.UFO_APP_VERSION,
        customerAppBuildNumber: configurations.UFO_APP_BUILD_NUMBER,
        serverApiVersion: '',
        systemName: browserName,
        systemVersion: browserVersion,
        model: osName
      }
    }

    const response = await postToApi(`v2/register/devices${partnerCode ? ('/' + partnerCode) : ''}`, body, true, true)

    if (response.data && response.data.apiToken && response.data.user) {
      this.apiToken = response.data.apiToken
      injectTokenInApi(response.data.apiToken)

      this.user = response.data.user
      initialiseAnalyticsUser(response.data.user, partnerCode)

      if (response.data?.config) {
        configurations.setConfigs(response.data.config)
      }

      if (response.data?.countryCode) {
        this.countryCode = response.data.countryCode
      }

      if (i18n.language === undefined && response.data?.user.language) {
        injectLanguageInApi(response.data.user.language)
      }

      return true
    }

    return false
  }

  @action async registerConnectedDevice(_connectedToken: string): Promise<boolean> {
    // always new device for now
    const body = {
      device: {
        type: 'web',
        customerAppName: configurations.UFO_APP_NAME,
        customerAppVersion: configurations.UFO_APP_VERSION,
        customerAppBuildNumber: configurations.UFO_APP_BUILD_NUMBER,
        serverApiVersion: '',
        systemName: browserName,
        systemVersion: browserVersion,
        model: osName
      }
    }

    const connectedRegisterApi = axios.create({
      headers: { 'Accept-Language': i18n.language, Authorization: 'Bearer ' + _connectedToken },
      baseURL: configurations.UFO_SERVER_PRIVATE_API_URL,
      timeout: 30000
    })

    let response = null
    try {
      response = await connectedRegisterApi.put('v3/register/connectedDevices', body)
    } catch (error: any) {
      console.error('Unable to register on connectedToken ', error)

      return false
    }

    if (response.data && response.data.apiToken && response.data.user) {
      this.apiToken = response.data.apiToken
      injectTokenInApi(response.data.apiToken)

      this.user = response.data.user
      initialiseAnalyticsUser(response.data.user)

      if (response.data?.config) {
        configurations.setConfigs(response.data.config)
      }

      this.connectedToken = _connectedToken

      return true
    }

    console.error('Unable to register on connectedToken: missing data is response!')

    return false
  }

  @action async updateMyself(user: IUser): Promise<boolean | string> {
    const response = await putToApi('v2/register/updateMyself', user, true, false)

    if (response.data && response.data.reference) {
      return true
    }

    return response.data?.message
  }
}

export default RegisterStore
